if (!customElements.get('mobile-product-gallery')) {
  customElements.define(
    'mobile-product-gallery',
    class MobileProductGallery extends HTMLElement {
      constructor() {
        super();
        this.mainImage = this.querySelector('.mobile-gallery__main-image img');
        this.thumbnails = this.querySelectorAll('.mobile-gallery__thumb');
        this.mainImageContainer = this.querySelector('.mobile-gallery__main-image');

        if (!this.mainImage || !this.thumbnails.length) return;

        this.thumbnails.forEach((thumb) => {
          thumb.addEventListener('click', this.onThumbClick.bind(this));
        });

        // Set first thumb as active
        if (this.thumbnails[0]) {
          this.thumbnails[0].classList.add('mobile-gallery__thumb--active');
        }
      }

      onThumbClick(event) {
        const clickedThumb = event.currentTarget;
        const fullSrc = clickedThumb.dataset.fullSrc;
        const fullSrcset = clickedThumb.dataset.fullSrcset;
        const fullAlt = clickedThumb.dataset.fullAlt || '';

        if (!fullSrc) return;

        // Update active state on thumbs
        this.thumbnails.forEach((t) => t.classList.remove('mobile-gallery__thumb--active'));
        clickedThumb.classList.add('mobile-gallery__thumb--active');

        // Swap main image
        const img = this.mainImage;
        img.style.opacity = '0';
        img.style.transition = 'opacity 0.2s ease';

        setTimeout(() => {
          img.src = fullSrc;
          if (fullSrcset) img.srcset = fullSrcset;
          img.alt = fullAlt;
          img.onload = () => {
            img.style.opacity = '1';
          };
          // Fallback in case onload doesn't fire (cached images)
          setTimeout(() => {
            img.style.opacity = '1';
          }, 300);
        }, 150);
      }
    }
  );
}
